/** @deprecated Legacy PDF report options — used only by localStorage migration. */
export enum ImageContent {
  none = 'none',
  main = 'main',
  all = 'all',
  allAsMiniatures = 'all_as_miniatures',
}
